import { useDispatch, useSelector } from "react-redux";
import dynamicfunction from "../../utils/dynamicfunction";
import { getContentKeyAccToLang } from "../../utils/utils";
import { useNavigate, useSearchParams } from "react-router";
import { setLanguage } from "../../store/slices/contentSlice";
import { languages } from "../../config/config";
import { useEffect } from "react";

export default () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const { TextWeight, isArabic } = dynamicfunction();

  const authContent = useSelector((state) => state.content?.authContent);

  useEffect(() => {
    const languageId = searchParams.get('languageId');
    if (languageId === '1') {
      dispatch(setLanguage({ language: languages.eng }));
    } else if (languageId === '2') {
      dispatch(setLanguage({ language: languages.arb }));
    }

    if (languageId) {
      setSearchParams((prev) => {
        const params = new URLSearchParams(prev);
        params.delete('languageId');
        return params;
      }, { replace: true });
    }
  }, [searchParams])

  const getContentKey = (key) => {
    return getContentKeyAccToLang(
      authContent?.web_onboarding?.data?.attributes,
      key,
      isArabic
    );
  };

  return {
    navigate,
    TextWeight,
    getContentKey,
    isArabic,
  }
}